import proj4 from "proj4";
import { register } from "ol/proj/proj4.js";

const registerProjection = () => {
    proj4.defs("EPSG:3006", "+proj=utm +zone=33 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs");
    register(proj4);
};

export default registerProjection;
